define('commons/tap-filter-selector',['jquery', 'commons/element-selector', 'commons/message-manager', 'commons/accordion-filter', 'commons/location-level'], 
    function($, ElementSelector, messages, AccordionFilter, LocationLevel) {

    var onOk = function() {
        if ($.isFunction(this.settings.onOkClick)) {
            var allSelected = this.elementSelector.model.allSelected;
            if (allSelected) {
                var question = "You have selected all the elements";
                var notSelectedArray = this.elementSelector.model.notSelected.asArray();
                if (notSelectedArray.length > 0) {
                    question += " except " + notSelectedArray.length + ". Continue? ";
                } else {
                    question += ". Continue? ";
                }
                if (confirm(question)) {
                    this.settings.onOkClick.call(this, notSelectedArray, allSelected);
                }
            } else {
                var selectedArray = this.elementSelector.model.selected.asArray();
                if (confirm("You have selected " + selectedArray.length + " elements. Continue?")) {
                    this.settings.onOkClick.call(this, selectedArray, allSelected);
                }
            }
        }
    };

    var loadFilterForm = function() {
        var okButtonId = getIdElement(this.settings.okButton, this.settings.suffix, 'ok-button', '#okButton');
        $(okButtonId).click($.proxy(onOk, this));

        var filterForm = getIdElement(this.settings.filterForm, this.settings.suffix, 'filter-form', '#filter-form');
        var headerContainer = getIdElement(false, this.settings.suffix, 'filter-form table.data thead', filterForm + ' table.data thead');
        var bodyContainer = getIdElement(false, this.settings.suffix, 'filter-form table.data tbody', filterForm + ' table.data tbody');
        var insertResultIn = getIdElement(this.settings.insertResultIn, this.settings.suffix, 'filter-result', '.filter-result');

        var filterFormOptions = {
            refresh : this.settings.refresh,
            dataType: this.settings.dataType,
            beanName: this.settings.beanName,
            beforeSearchLoad : this.settings.beforeSearchLoad,
            searchLoaded : this.settings.searchLoaded,
            onDataLoaded: [this.settings.onDataLoaded, $.proxy(this.elementSelector.onDataLoaded, this.elementSelector)],
            headerContainer : headerContainer,
            bodyContainer : bodyContainer,
            insertResultIn : insertResultIn
        }
        if (this.settings.emptyMessage) {
            filterFormOptions.emptyMessage = this.settings.emptyMessage;
        }
        if(!this.accordionFilterForm){
            this.accordionFilterForm = new AccordionFilter(filterForm, filterFormOptions);
            var locationLevel = new LocationLevel("#tap-filter-selector .location-level", {
                data: []
            });
        }
    };

    var resetFilterForm = function() {
        if (this.accordionFilterForm.reset()) {
            $(this.accordionFilterForm.form).submit();
        }
    };

    var loadSelectedData = function() {
        if (this.settings.fullRefreshUrl) {
            this.tapPopupContent.addClass("loading");
            $.ajax({
                type: 'GET',
                url: this.settings.fullRefreshUrl,
                dataType: "json",
                success: function(spots) {
                    this.settings.onFullRefresh.call(this, spots.spots);
                    this.tapPopupContent.removeClass("loading");
                    this.loaded = true;
                },
                context: this
            });
        } else {
            this.loaded = true;
        }
    };
    
    var getIdElement = function(element, suffix, suffixId, defaultId) {
        return element ? element : suffix ? '#' + suffix + '-' + suffixId : defaultId;
    }

    var methods = {
        init: function(options) {
            this.settings = {
                dialogOptions: {
                    'autoOpen': false,
                    'resizable': true,
                    'minWidth': 600,
                    'width': '70%',
                    'height': 700,
                    'zindex': 200,
                    'draggable': true,
                    'dialogClass': 'list-selector-dialog',
                    //'modal': true
                },
                onDataLoaded: null,
                tapContent: false,
                refresh: false,
                data: function() {
                    return {};
                },
                onOkClick: null,
                suffix: false,
                beanName : '',
                dataType : 'json',
                emptyMessage : false,
                filterContainer : false,
                selectAll : false,
                unselectAll : false,
                okButton : false,
                insertResultIn : false,
                headerContainer : false,
                bodyContainer : false,
                filterForm : false,
                fullRefreshUrl : false,
                beforeSearchLoad : function(){},
                searchLoaded : function(){}
            };
            $.extend(true, this.settings, options);
            this.loaded = false;
            this.id = this.settings.suffix ? '_' + this.settings.suffix : '';
            this.settings.tapContent = this.settings.tapContent ? this.settings.tapContent : '#tapcontent' + this.id;
            // Create toolbar
            this.tapPopup = this.first().dialog(this.settings.dialogOptions);
            this.tapPopup.dialog("option", "title", this.settings.title);
            var cont = $(this.tapPopup.dialog("widget").find(".ui-dialog-content"));
            // get content
            this.tapPopupContent = cont.find(this.settings.tapContent);

            var filterForm = getIdElement(this.settings.filterForm, this.settings.suffix, 'filter-form', '#filter-form');
            this.elementSelector = new ElementSelector(filterForm + ' #list-container', {
                selectAll : getIdElement(this.settings.selectAll, this.settings.suffix, 'select-all', '#selectAll'),
                unselectAll : getIdElement(this.settings.unselectAll, this.settings.suffix, 'unselect-all', '#unselectAll'),
            });

            return this;
        },
        open: function() {
            this.tapPopup.dialog("open");
            if (!this.loaded) {
                loadFilterForm.apply(this);
            } else {
                resetFilterForm.apply(this);
            }
            loadSelectedData.apply(this);
        },
        close: function() {
            this.tapPopup.dialog("close");
        }
    };

    $.fn.tapFilterSelector = function(method) {
        // Method calling logic
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist on jQuery.tooltip');
        }
        return this;
    };
});
